/**
 * Abstract base that owns `previous` / `next` and provides concrete
 * implementations of all doubly-linked-list structural and traversal helpers.
 *
 * `T` must itself extend `IDoublyLinkedListNode<T>` so that the traversal
 * helpers can follow the typed chain without unsafe casts.
 *
 * @example
 *   class MyNode extends DoublyLinkedListNode<MyNode> { ... }
 */
export class DoublyLinkedListNode {
    previous = null;
    next = null;
    // ── Structural helpers ─────────────────────────────────────────────────────
    insertAfter(node) {
        node.previous = this;
        node.next = this.next;
        if (this.next) {
            this.next.previous = node;
        }
        this.next = node;
    }
    insertBefore(node) {
        node.next = this;
        node.previous = this.previous;
        if (this.previous) {
            this.previous.next = node;
        }
        this.previous = node;
    }
    replaceWith(node) {
        node.previous = this.previous;
        node.next = this.next;
        if (this.previous) {
            this.previous.next = node;
        }
        if (this.next) {
            this.next.previous = node;
        }
        this.previous = null;
        this.next = null;
    }
    // ── Traversal helpers ──────────────────────────────────────────────────────
    getRoot() {
        let current = this;
        while (current.previous) {
            current = current.previous;
        }
        return current;
    }
    getTail() {
        let current = this;
        while (current.next) {
            current = current.next;
        }
        return current;
    }
    toArray() {
        const result = [];
        let current = this.getRoot();
        while (current) {
            result.push(current);
            current = current.next;
        }
        return result;
    }
    getIndex() {
        let index = 0;
        let current = this.previous;
        while (current) {
            index++;
            current = current.previous;
        }
        return index;
    }
}
//# sourceMappingURL=doubly-linked-list.js.map